import { GenericCard, OverviewList, PageHeader } from '@components/molecules';
import { CustomerNotes } from '@components/organisms';
import { useSingleCustomer } from '@hooks';
import { Buildings, PencilSimple, UsersThree } from '@phosphor-icons/react';

import { CardForm, WrapperPage } from '@components/atoms';
import {
	formatCurrency,
	maskBirthdate,
	maskCPF,
	maskDate,
	maskDateWithTime,
} from '@helpers';

import { Button } from 'antd';
import { useNavigate, useParams } from 'react-router-dom';

const styleHoverCard = 'cursor-pointer hover:shadow-lg transition-shadow';

export const CustomerDetails = () => {
	const { customerId } = useParams();
	const navigate = useNavigate();
	const { data: customer, isLoading, refetch } = useSingleCustomer(customerId!);
	const defaultMember = customer?.defaultMember;
	const lastUpdatedNotes = customer?.lastUpdatedNotes;
	const lastUpdatedNotesFormatted = lastUpdatedNotes
		? maskDateWithTime(lastUpdatedNotes)
		: '--';
	const notes = customer?.notes || 'No notes yet.';

	const customerData = [
		{
			title: 'Full name',
			response: defaultMember?.name,
		},
		{
			title: 'CPF',
			response: defaultMember && maskCPF(defaultMember?.cpf as string),
		},
		{
			title: 'Date of birth',
			response:
				defaultMember &&
				`${maskDate(defaultMember.birthday)} (${maskBirthdate(
					defaultMember.birthday
				)})`,
		},
		{
			title: 'Occupation',
			response: defaultMember?.profession,
		},
		{
			title: 'Monthly income',
			response: defaultMember?.monthlyIncome,
		},
	];

	return (
		<WrapperPage isLoading={isLoading}>
			<PageHeader title={defaultMember?.name || ''} />
			<div className='space-y-6'>
				<CardForm>
					<h2 className='text-lg font-semibold mb-4'>Client information</h2>

					<span className='absolute top-6 right-6'>
						<Button
							icon={<PencilSimple />}
							type='primary'
							size='large'
							href={`/clientes/${customerId}/familia`}
						/>
					</span>

					<div className='flex flex-col md:flex-row gap-6'>
						<div className='flex-1'>
							<OverviewList items={customerData} />
						</div>

						<div className='flex-1'>
							<OverviewList items={[]} />
						</div>
					</div>
				</CardForm>
				<div className='grid grid-cols-1 md:grid-cols-2 gap-6'>
					<GenericCard
						icon={<UsersThree />}
						title='Family'
						subtitle={''}
						className={styleHoverCard}
						onClick={() => navigate(`/clientes/${customerId}/familia`)}
					/>
					<GenericCard
						icon={<Buildings />}
						title='Assets'
						subtitle={formatCurrency(customer?.patrimonyTotal ?? 0)}
						className={styleHoverCard}
						onClick={() => navigate(`/clientes/${customerId}/patrimonio`)}
					/>
				</div>
				<CustomerNotes
					customerId={customerId!}
					initialNotes={notes}
					lastUpdatedNotes={lastUpdatedNotesFormatted}
					onRefetch={refetch}
				/>
			</div>
		</WrapperPage>
	);
};
